import { GtmEvents } from '@/gtm/gtm-events';

export class MindboxGtmEvents extends GtmEvents {
  onUpdateProfile(params) {
    return this.gtmEvent({
      event: 'MB_LK_Edit',
      params,
    });
  }

  onAuth({
    email = '', mobilePhone = '', firstName = '', emailSubscription = false, accountId = '',
  } = {}) {
    const eventParams = {
      customer: {
        email,
        mobilePhone,
        ids: {
          userwebsitefunday: accountId,
          clubproid: accountId,
        },
        firstName,
      },
    };

    if (emailSubscription) {
      eventParams.subscriptions = [{
        brand: 'Funday',
        pointOfContact: 'Email',
      }];
    }

    return this.gtmEvent({
      event: 'MB_auth',
      params: eventParams,
    });
  }
}

export const mindboxGtmEvents = new MindboxGtmEvents();
